<template>
  <div
    class="relative flex flex-col text-gray-900 bg-checkered-white bg-repeat bg-[length:30px] border border-gray-200 p-8 rounded"
  >
    <NuxtPicture
      :src="path + '.' + firstFileType"
      class="max-h-24 preview-img"
    />
    <div class="absolute right-2 bottom-2 flex flex-row gap-2 font-semibold">
      <a
        v-if="png"
        class="hover:underline"
        :title="$t('jc.view.branding.image.png.download.title')"
        :href="path + '.png'"
        target="_blank"
        download
      >png</a>
      <a
        v-if="svg"
        class="hover:underline"
        :title="$t('jc.view.branding.image.svg.download.title')"
        :href="path + '.svg'"
        target="_blank"
        download
      >svg</a>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  path: {
    type: String,
    required: true,
  },
  png: {
    type: Boolean,
    required: false,
  },
  svg: {
    type: Boolean,
    required: false,
  },
})

const firstFileType = ref(props.png ? 'png' : 'svg')
</script>
